<!--  -->
<template>
  <div v-loading="loading">
    <div>
      <span class="title">公众号名称:</span>
      <el-tag>{{ Frow.account_name }}</el-tag>
    </div>
    <div style="margin: 10px 0;">
      <span
        class="title"
        style="margin-right:38px;"
      >APPID:</span>
      <el-tag>{{ Frow.app_id }}</el-tag>
    </div>
    <el-card class="box-card">
      <div>
        <div>通过广告关注的回复：</div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          style="width: 50px;height: 38px;margin: 5px 0;"
          @click="copy"
        />
        <div style="margin: 20px 0; max-height: 250px;overflow-y: scroll;">
          <div
            v-for="item,i in ad_reply_info"
            :key="i"
            style="display: flex;margin-bottom: 10px;"
          >
            <span style="margin: 10px;">第{{ i+1 }}条</span>
            <el-select
              v-model="item.type"
              style="max-width: 150px;"
              placeholder="请选择"
            >
              <el-option
                label="文本"
                value="TEXT"
              />
              <el-option
                label="图片"
                value="IMAGE"
              />
            </el-select>
            <el-card style="margin-left: 10px;width: 300px;">
              <div
                v-if="item.type==='TEXT'"
                style="display: flex;"
              >
                <span style="width: 50px;">内容:</span>
                <el-input
                  v-model="item.content"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                />
              </div>
              <div
                v-if="item.type==='IMAGE'"
                style="display: flex;"
              >
                <span style="width: 50px;">图片:</span>
                <el-button
                  type="success"
                  size="mini"
                  style="height: 30px;"
                  @click="materiallibrary(i,1)"
                >选择</el-button>
                <img
                  v-if="item.url"
                  :src="item.url"
                  class="pic_img"
                >
              </div>
            </el-card>
            <el-button
              style="float: right;margin-left: 10px;height: 35px;"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="deleteitem(i)"
            />
          </div>
        </div>

      </div>
    </el-card>
    <el-card class="box-card">
      <div>
        <div>非广告关注的回复
          ：</div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          style="width: 50px;height: 38px;margin: 5px 0;"
          @click="copy(1)"
        />
        <div style="margin: 20px 0; max-height: 250px;overflow-y: scroll;">
          <div
            v-for="item,i in un_ad_reply_info"
            :key="i"
            style="display: flex;margin-bottom: 10px;"
          >
            <span style="margin: 10px;">第{{ i+1 }}条</span>
            <el-select
              v-model="item.type"
              style="max-width: 150px;"
              placeholder="请选择"
            >
              <el-option
                label="文本"
                value="TEXT"
              />
              <el-option
                label="图片"
                value="IMAGE"
              />
            </el-select>
            <el-card style="margin-left: 10px;width: 300px;">
              <div
                v-if="item.type==='TEXT'"
                style="display: flex;"
              >
                <span style="width: 50px;">内容:</span>
                <el-input
                  v-model="item.content"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                />
              </div>
              <div
                v-if="item.type==='IMAGE'"
                style="display: flex;"
              >
                <span style="width: 50px;">图片:</span>
                <el-button
                  type="success"
                  size="mini"
                  style="height: 30px;"
                  @click="materiallibrary(i)"
                >选择</el-button>
                <img
                  v-if="item.url"
                  :src="item.url"
                  class="pic_img"
                >
              </div>
            </el-card>
            <el-button
              style="float: right;margin-left: 10px;height: 35px;"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="deleteitem(i,1)"
            />
          </div>
        </div>

      </div>
    </el-card>
    <el-button
      style="margin-top: 20px;"
      type="primary"
      class="brwbtn"
      @click="addbtn"
    >确 定</el-button>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>

  </div>
</template>

<script>
import chooseimg from '@/views/sourceMaterial/components/imgComp.vue'

import { replay_infos } from '@/api/report/accountManagement'
export default {
  components: { chooseimg },
  data() {
    return {
      Frow: {},
      ad_reply_info: [
        // {
        //   content: '',
        //   type: 'TEXT',
        //   url: ''
        // }
      ],
      un_ad_reply_info: [
        // {
        //   content: '',
        //   type: 'TEXT',
        //   url: ''
        // }
      ],
      isUploading: false,
      temporary: '',
      arrindex: '',
      dialogVisibletwo: false,
      sign: false,
      loading: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    materiallibrary(i, type) {
      this.temporary = type
      this.arrindex = i
      this.dialogVisibletwo = true
      setTimeout(() => {
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key, name) {
      console.log('img, key:', img, key, name)
      this.dialogVisibletwo = false
      if (this.temporary === 1) {
        this.ad_reply_info[this.arrindex].url = img
        // this.form.source_material_id = key
      } else {
        this.un_ad_reply_info[this.arrindex].url = img
      }
    },
    async addbtn() {
      console.log(this.ad_reply_info)

      // const hasNonEmptyObject = this.ad_reply_info.every(obj => obj.content !== '' || obj.url !== '')

      const emptyIndex = this.ad_reply_info.findIndex(obj => obj.content === '' && obj.url === '')
      const unemptyIndex = this.un_ad_reply_info.findIndex(obj => obj.content === '' && obj.url === '')

      if (emptyIndex !== -1) {
        console.log('第一个空对象的索引是:', emptyIndex)
        return this.$message(`广告关注的回复中的第${emptyIndex + 1}条内容为空`)
      } else if (unemptyIndex !== -1) {
        return this.$message(`非广告关注的回复中的第${unemptyIndex + 1}条内容为空`)
      }
      console.log('this.sign:', this.sign)
      if (this.sign) {
        console.log('this.un_ad_reply_info:', this.un_ad_reply_info, this.ad_reply_info)
        if (this.un_ad_reply_info.length === 0 && this.ad_reply_info.length === 0) {
          return this.$message('不可以添加空的内容哦')
        }
      }
      const obj = {
        wechat_account_id: this.Frow.app_id,
        type: 1,
        ad_reply_info: this.ad_reply_info,
        un_ad_reply_info: this.un_ad_reply_info
      }

      this.$emit('handupdata', obj)
      // if (!hasNonEmptyObject) {
      //   console.log('请删除具有空内容和空URL的对象。')
      // } else {
      //   // 继续执行后续代码
      // }
    },
    deleteitem(index, type) {
      if (type === 1) {
        this.un_ad_reply_info.splice(index, 1)
        return
      }
      this.ad_reply_info.splice(index, 1)
    },
    copy(type) {
      if (type === 1) {
        this.un_ad_reply_info.push({
          content: '',
          type: 'TEXT',
          url: ''
        })
        return
      }
      this.ad_reply_info.push({
        content: '',
        type: 'TEXT',
        url: ''
      })
    },
    sendr(row) {
      console.log('row:', row)
      this.Frow = row
      this.setReplay_infos()
    },
    async setReplay_infos() {
      this.loading = true

      const res = await replay_infos({
        wechat_account_id: this.Frow.app_id
      })
      console.log(res)
      const { un_ad_reply_info, ad_reply_info } = res.data
      console.log('un_ad_reply_info.length === 0:', un_ad_reply_info.length === 0)
      if (un_ad_reply_info.length === 0 && ad_reply_info.length === 0) {
        this.sign = true
      } else {
        this.sign = false
      }
      console.log(' this.sign:', this.sign)
      if (un_ad_reply_info.length !== 0) {
        this.un_ad_reply_info = un_ad_reply_info
      } else {
        this.un_ad_reply_info = []
      }
      if (ad_reply_info.length !== 0) {
        this.ad_reply_info = ad_reply_info
      } else {
        this.ad_reply_info = []
      }
      this.loading = false
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.pic_img {
  width: 100px;
  height: 100px;
  padding: 10px;
}
.box-card {
  margin-bottom: 20px;
}
.title {
  margin-right: 10px;
}
</style>
